import Modal from "../../common/Modal";
import FileUpload from "./FileUpload";
import { useEffect, useState } from "react"; 
import FullPageLoader from "../../common/FullPageLoader";
import uploadedIcon from "../../../webroot/images/successSign.svg";
import { useSelector, useDispatch } from "react-redux";
import { getMasterData } from "../../../store/action/allAction";
import { useApolloClient } from '@apollo/client';


function PdfUploader(props) {
    const [loading, setLoading] = useState(false);
    const [fileUplodValue, setPdfUpload] = useState({
        pdfUpload: false,
        pdfUploadStatus: false,
        pdfUploadMsg: false
    })
    const [pdfUploadPopUp, setPdfUploadPopUp] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [csvSampleUrl, setCsvSampleUrl] = useState(""); 
    const dispatch = useDispatch()
    const masterState = useSelector((state) => state.masterdata)
    const client = useApolloClient();
    const [bulkUploadType, setBulkUploadType] = useState(1);

    useEffect(() => {
        if (!Object.keys(masterState?.data)?.length) {
            dispatch(getMasterData(client)); 
        } else { 
            let { sample_csv} = masterState?.data; 
            const incentiveSample = sample_csv.find(sample => sample.type === "incentive");  
            setCsvSampleUrl(incentiveSample?.url)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) //NOTE_TO_DEV: removing masterState as dependency as when API is failing it is going in infinite api call
 
    useEffect(()=>{ 
        if(props.handlePdfUploader && props.handlePdfUploader.pdfUpload){   //SHOW POPUP IF OPENED
            setPdfUpload(prev => ({
                ...prev, pdfUpload: true,type:1
            }))
        } 
    }, [props.handlePdfUploader])
 
    /**
     * BULK UPLOAD STATUS HANDLER
     * @param {*} params 
     */
    const uploadStatusHandler = (params) => {
        setPdfUpload({
            ...fileUplodValue, ...params
        })
    }

    const showModalPdfUploadPopUp = () => {
        setPdfUploadPopUp(true)
        document.body.classList.add("overflow-hidden");
    }

    const hideModalPdfUploadPopUp = () => {
        setPdfUploadPopUp(false);
        let filters = {...props.filters};
        props.getDataListing(filters);
        setBulkUploadType(1);
        document.body.classList.remove("overflow-hidden");
    }

    const hideSuccessMsgPopUp = () => {
        setShowSuccessMsg(false);
        setBulkUploadType(1);
        document.body.classList.remove("overflow-hidden");
    }

    const showSuccessMsgPopUp = () => {
        setShowSuccessMsg(true);
        document.body.classList.add("overflow-hidden");
    } 
    const setBulkUpload = (e) => {
        setBulkUploadType(Number(e.target.value))
    }

    return (

        <>
        <button className="btn-line btn-export" onClick={showModalPdfUploadPopUp} > <span className={""}><i className={"ic-upload"}></i> </span>{"Bulk Upload"}</button>
        { pdfUploadPopUp && 
        <div className="model-popup-outer upload-csv-popup z-index">
             <FullPageLoader show={loading} />
                <Modal show={pdfUploadPopUp} handleClose={()=>hideModalPdfUploadPopUp()}>
                    <div className="modal-header">
                    <h2>Dealer Incentive - Bulk Upload</h2>
                        <div className="radio-btn p-lg-b"  >
                            <div className="radio-type-txt d-flex" > 
                                <div className="custom-control custom-checkbox m-md-r">
                                    <input
                                        id="replace_all_data"
                                        type="radio"
                                        className="custom-control-input "
                                        name="replace_all_data"
                                        value={1}
                                        onChange={(e) => setBulkUpload(e)}
                                        style={{ cursor: 'pointer' }}
                                        checked={bulkUploadType === 1}
                                    />
                                    <label className="custom-control-label">
                                        <span>Replace All Data</span>
                                    </label>
                                </div>
                                <div className="custom-control custom-checkbox">
                                    <input
                                        id="update_existing"
                                        type="radio"
                                        className="custom-control-input "
                                        name="update_existing"
                                        value={2}
                                        onChange={(e) => setBulkUpload(e)}
                                        style={{ cursor: 'pointer' }}
                                        checked={bulkUploadType === 2}
                                    />
                                    <label className="custom-control-label">
                                        <span>Update Existing/Add New Data</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-body">
                    <FileUpload bulkUploadType={bulkUploadType} setLoading={setLoading} uploadStatusHandler={uploadStatusHandler} hideModalPdfUploadPopUp={() => hideModalPdfUploadPopUp()} showSuccessMsgPopUp={showSuccessMsgPopUp} csvSampleUrl={csvSampleUrl}/>

                    </div>
                </Modal>
            </div>
            } 

      { showSuccessMsg && 
        <div className="model-popup-outer csv-success-msg-popup">
             <FullPageLoader show={loading} />
                <Modal show={showSuccessMsg} handleClose={()=>hideSuccessMsgPopUp()}> 
                    <div className="modal-body">
                        <img src={uploadedIcon} className="" alt='logo' />
                         <h2>Bulk Incentive has been Uploaded Successfully.</h2>
                    </div>      
                </Modal>
            </div>
            } 
        </>
        
  );
}

export default PdfUploader;